import type { LargeListFilterValue } from '../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericLargeListFilter/GenericLargeListType';
import { FilterKindEnum } from '../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../LabelFormatterType';
import { getLabels as largeListLabelFormatterGetLabels } from './GenericLabelFormatter/LargeListLabelFormatter';

export function getLabels(currentValue?: LargeListFilterValue<string>): LabelProps {
  const optionList = (currentValue?.selectedValues ?? []).map((item) => ({
    value: item,
    label: item,
  }));
  return largeListLabelFormatterGetLabels(currentValue, FilterKindEnum.Event, { optionList });
}
